<div class="job-skeleton-container" [class.cm-view]="isCMView" data-testid="job-skeleton-container">
    <div class="job-skeleton-grid">


        @if (isCMView) {
            <p-skeleton width="12rem" height="1rem" class="mb-2" />
            <p-skeleton width="16rem" height="3rem" class="mb-2" />
            <p-skeleton width="8rem" height="1rem" class="mb-2" />
            <p-skeleton width="8rem" height="1rem" class="mb-2" />
            <p-skeleton width="9rem" height="2.5rem" class="mb-2 skeleton-separator" />
        } @else {
            <p-skeleton width="12rem" height="1rem" class="mb-2" />
            <p-skeleton width="16rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="5.5rem" height="2.5rem" class="mb-2 skeleton-separator" />
        }
    </div>
</div>
